/* Shared visitor geo lookup — cached per session */
let geoPromise = null;

const EMPTY_GEO = { country: null, country_code: null, city: null, region: null };

/* Crawlers / pre-renderers: skip every non-essential network call so the page reaches network-idle fast */
export const isBot = () =>
  typeof navigator !== "undefined" &&
  (/bot|crawl|spider|slurp|prerender|headless|lighthouse|google|bing|yandex|duckduck|baidu|facebookexternalhit|embedly|quora|pinterest|whatsapp|telegram|twitterbot|linkedinbot/i.test(navigator.userAgent) ||
    navigator.webdriver === true);

export const getGeo = () => {
  if (isBot()) return Promise.resolve(EMPTY_GEO);
  const cached = sessionStorage.getItem("ahjin_geo");
  if (cached) {
    try { return Promise.resolve(JSON.parse(cached)); } catch (e) { /* refetch */ }
  }
  if (!geoPromise) {
    geoPromise = fetch("https://ipapi.co/json/")
      .then((r) => r.json())
      .then((d) => {
        const geo = {
          country: d.country_name || null,
          country_code: d.country_code || null,
          city: d.city || null,
          region: d.region || null,
        };
        sessionStorage.setItem("ahjin_geo", JSON.stringify(geo));
        return geo;
      })
      .catch(() => {
        const geo = { country: null, country_code: null, city: null, region: null };
        sessionStorage.setItem("ahjin_geo", JSON.stringify(geo));
        return geo;
      });
  }
  return geoPromise;
};
